<template lang="pug">
  div
    slide-drawer(
        v-model="showDrawer"
      )
        template(slot="title")
          span Export Contacts
        template(slot="content")
          v-container
            p.ma-2.subheading We will notify you via email when your document is available to download on your  
              span.blue--text.text--darken-4.font-weight-bold
                router-link(to="/documents") Documents
              |  under the folder "Uncategorized".
            div.mt-3
              p.ma-2 Select the format to export
              v-radio-group.ml-2(v-model="fileType")
                v-layout(align-center justify-start row fill-height)
                  v-flex
                    v-radio(label="CSV" value="csv")
                  v-flex
                    v-radio(label="XLSX" value="xlsx")
            p.ma-2(id="limitError" v-if="fileType === 'xlsx' && isOverXLSFileLimit") You have more than 65,000 contacts on your export, this exceeds the limit XLSX formats have, please select CSV to continue.
            div.mt-3
              p.ma-2 Select the range of the data to export
              v-radio-group.ml-2(v-model="allColumns")
                v-radio(label="Export columns visible in the window" :value="false")
                v-radio(label="Export all columns about the contact" :value="true")
            p.ma-2 Permission of download link
            v-switch.ml-2.my-1(v-model="isPrivate" label="Make your exported file private")
            ul.ml-2.mt-3
              li
                p.ma-2 Only contacts you owned will be exported. Contacts assigned or shared with you will not be exported, this might cause 
                  | your contacts export to have a difference in count.
              li
                p.ma-2 Making your exported file private will only let you download the file from the link that will be generated and sent via email.
            a
              p.mx-2.mt-5.blue--text.text--darken-4.subheading.font-weight-bold.text-xs-center(@click="showExportHistoryModal()") View export history
              export-history-modal(
                v-model="shouldShowExportHistoryModal",
                @close="shouldShowExportHistoryModal = false",
              )

        template(slot="actions")
          v-btn(
            id="exportButton"
            color="primary"
            :disabled="!isFormValid"
            :loading="isLoading"
            @click="startContactExportProcess()"
          ) Export

</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import SlideDrawer from '@/Core/components/SlideDrawer';

const {
  mapActions: mapContactsExportActions,
  mapState: mapContactsExportState,
  mapMutations: mapContactsExportMutations,
} = createNamespacedHelpers('contactsExport');

export default {
  components: {
    SlideDrawer,
    ExportHistoryModal: () =>
      import(
        /* webpackChunkName: 'ExportHistoryModal' */ '@/Contacts/components/export/ExportHistoryModal'
      ),
  },
  props: {
    value: Boolean,
    contactsCount: Number,
    headers: Array,
  },
  data() {
    return {
      fileType: 'csv',
      allColumns: false,
      isPrivate: false,
      XLSFileLimit: 65000,
      shouldShowExportHistoryModal: false,
    };
  },
  computed: {
    ...mapContactsExportState(['showContactExportDrawer','isLoading']),
    isFormValid() {
      return this.fileType && this.allColumns !== null && this.validFileType;
    },
    showDrawer: {
      get() {        
        return this.showContactExportDrawer;
      },
      set(value) {
        if (!value) this.resetFields();
        this.setShowContactExportDrawer(value);
      },
    },
    isOverXLSFileLimit() {
      return this.contactsCount >= this.XLSFileLimit;
    },
    validFileType() {
      if (this.fileType === "xlsx") return !this.isOverXLSFileLimit;
      return true;
    },
    csvCustomColumns() {
      return this.headers.reduce((acc, header) => {
        if (header.type !== "address") {
          if (header.value === "phone_mobile") {
            acc.push(header.value, "sms_opt_in");
          } else {
            acc.push(header.value);
          }
        } else {
          const addressType = this.formatAddressType(header.address_type);
          acc.push(`${addressType}_${header.value}`);
        }
        return acc;
      }, []);
    },
    columnsOrder() {
      let phoneMobileOffset = 0
      return this.headers.filter(header => header.order || header.order >= 0)
        .reduce((acc, header) => {
          if (header.type !== "address") {
            const colOrder = { [header.order + phoneMobileOffset]: header.value }
            if (header.value === "phone_mobile") {
              const smsOptInsOrder = { [header.order + 1]: "sms_opt_in" };
              phoneMobileOffset++
              return { ...acc, ...colOrder, ...smsOptInsOrder };
            }
            return { ...acc, ...colOrder }
          }

          const addressType = this.formatAddressType(header.address_type);
          const colOrder = { [header.order + phoneMobileOffset]: `${addressType}_${header.value}` }
          return { ...acc, ...colOrder }
        }, {})
    },
  },
  methods: {
    ...mapContactsExportMutations(['setShowContactExportDrawer']),
    ...mapContactsExportActions(['initContactExport']),
    startContactExportProcess() {
      this.initContactExport({
        fileType: this.fileType,
        allColumns: this.allColumns,
        isPrivate: this.isPrivate,
        csvCustomColumns: this.csvCustomColumns,
        columnsOrder: this.columnsOrder,
      })
    },
    resetFields() {
      this.fileType = 'csv';
      this.allColumns = false;
      this.isPrivate = false;
    },
    showExportHistoryModal() {
      this.shouldShowExportHistoryModal = true;
    },
    formatAddressType(type) {
      return type.toLowerCase().replace(' ', '_');
    }
  }
}
</script>
